// export this package's api
import Upload from './Upload'

export default Upload



// WEBPACK FOOTER //
// ./components/vc-upload/src/index.js